import requestAction from '../../utils/requestAction'

export const fetchProductMeasurement = (productMeasurementId: string) =>
  requestAction('PRODUCTMEASUREMENT_DETAIL')(`productMeasurements/${productMeasurementId}`, 'GET')
